import React from "react";
import { InfoSmallIcon, Tooltip } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

const SubscriptionInfoIconWithTooltip = ({ title, wide }) => {
  return (
    <Tooltip
      title={title}
      isLight
      placement="bottom"
      className={classnames("tw-p-4 tw-max-w-[300px]", {
        "tw-w-[300px]": wide,
        "tw-w-[270px]": !wide,
      })}
    >
      <InfoSmallIcon className="tw-cursor-pointer" />
    </Tooltip>
  );
};

SubscriptionInfoIconWithTooltip.propTypes = {
  title: PropTypes.node,
  wide: PropTypes.bool,
};

export default SubscriptionInfoIconWithTooltip;
